module.exports = __webpack_public_path__ + "img/index_pic4.07059b67.png";